<template>
  <div class="topic__list" v-if="topicList">
    <div
      :key="topic.caseId"
      v-for="topic of topicList"
      class="topic__item"
    >
      <h2 class="topic__title">{{ topic.moduleTitle }}</h2>
      <div class="topic__line"></div>
      <div
        class="video__list"
        :style="{ height: (height[topic.caseId] || 194) + 'px' }"
      >
        <div
          v-for="(video, vIdx) of topic.videoList"
          :key="video.caseId"
          class="video__item"
          @click="playVideo(vIdx, video, topic.caseId, topic.videoList.length)"
        >
          <!-- <template v-if="vIdx < topic.videoList.length"> -->
          <div class="video__cover">
            <img class="video__img" :src="video.ottImgUrl" :alt="video.name" />
          </div>
          <div class="video__name">
            {{ video.name || video.subName || video.jumpDefaultParam[0].title }}
          </div>
        </div>
      </div>
      <p
        v-if="topic.videoList.length > 5"
        class="topic__more"
        @click="showMore(topic.caseId, topic.videoList.length)"
      >
        <span>{{ height[topic.caseId] > 194 ? "点击收起" : "查看更多" }}</span>
        <img
          src="./images/arrow.png"
          :class="{ rotate: height[topic.caseId] > 194 }"
        />
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'topic',
  props: {
    topicList: Array
  },
  data () {
    return {
      height: {}
    }
  },
  computed: {

  },
  methods: {
    showMore: function (caseId, len) {
      console.log(caseId, len)
      len = len || 0
      if (this.height[caseId] > 194) {
        this.$set(this.height, caseId, 194)
      } else {
        this.$set(this.height, caseId, 194 * Math.ceil(len / 5))
      }
    },
    playVideo: function (idx, vi) {
      this.$emit('play', vi)
    }
  }
}
</script>

<style>
.klk .topic__item {
  background-color: #eaf6ff;
}
.xzs .topic__item {
  background-color: #f1fde3;
}
.topic__item {
  position: relative;
  box-sizing: border-box;
  background: #ecf9ff;
  margin-bottom: 40px;
  padding: 40px 30px;
}
.topic__title {
  font-size: 30px;
  line-height: 30px;
  font-weight: 400;
  color: #232222;
  margin: 0;
}
.topic__line {
  width: 49px;
  height: 2px;
  margin: 8px 0 13px 2px;
  background: #e41e15;
}
.video__list {
  margin: 0 -15px;
  overflow: hidden;
  transition: all ease 1s;
}
.video__item {
  float: left;
  width: 204px;
  cursor: pointer;
  padding: 0 15px;
  margin: 10px 0;
}
.video__cover {
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 204px;
  height: 114px;
}
.video__img {
  width: 100%;
  height: 100%;
}
.video__icon {
  width: 34px;
  height: 34px;
}
.video__icon-text {
  font-size: 14px;
  margin-top: 11px;
}
.video__name {
  font-size: 14px;
  color: #676767;
  padding: 20px 12px 0;
  height: 40px;
  line-height: 20px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.topic__more {
  position: absolute;
  left: 50%;
  bottom: 10px;
  margin: 0;
  width: 125px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 14px;
  color: #4a4a4a;
  cursor: pointer;
  background-color: #eee;
  transform: translateX(-50%);
}
.topic__more img {
  margin-left: 6px;
  transition: all ease 0.3s;
  vertical-align: -3px;
}
.topic__more img.rotate {
  transform: rotate(180deg);
}
</style>



// WEBPACK FOOTER //
// src/components/topic.vue